import { buildSlice, CommonState } from '~libs/reduxUtils';

import { getAll, getOne, typePrefix } from '~lookups/actions/statementDeliveryPreferences';

import { Lookup } from '../models';

const initialState: CommonState<Lookup> = {
  loading: 'idle',
  hasLoaded: false,
  error: null,
  rows: [],
  row: undefined,
};

const slice = buildSlice<CommonState<Lookup>, Lookup>(typePrefix, initialState, {
  commonConfig: { getAll, getOne },
});

export const { clear, updateParams } = slice.actions;
export default slice.reducer;
